import React from 'react'
import {CounterInterface, ThresholdType} from "../../../store/types/CustomerAgreementCondition";
import {convertToMinutesAndSeconds, SUPPORTED_TIME_UNITS} from "./BundleRow.utils";
import {roundUp} from "../../../utils/roundUp";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/styles";
import {Colors} from "../../../styles/Colors";
import {ThresholdValue} from '../../../utils/treshold.enum';

export type ResourceMeterProps = {
    product: CounterInterface
    useStyling?: boolean
};

const useStyles = makeStyles(() => ({
    resourceMeterContainer: {
        display: 'grid',
        columnGap: 6,
        gridTemplateColumns: 'auto auto auto',
        '& div': {
            display: 'inline-grid'
        }
    },
    usedQuantity: {
        color: Colors.Text,
        fontWeight: 400,
    },
    maxQuantity: {
        color: Colors.Gray12,
        fontWeight: 400
    },
}))

const usedQuantityElementId = 'product-row-used-quantity'
const maxQuantityElementId = 'product-row-max-quantity'

const ResourceMeter: React.VFC<ResourceMeterProps> = ({product, useStyling = true}) => {

    const {t} = useTranslation()
    const classes = useStyles()

    const title = t('enums:standardServiceName.' + product.i_service, product.service_name)
    const unitsShort = t(`units:short.${product.unit}`, product.unit, title)

    const isTimeUnit = product.threshold_type === ThresholdType.Time || SUPPORTED_TIME_UNITS.includes(product.unit)

    const formattedCurrentValue = isTimeUnit ?
        convertToMinutesAndSeconds(Number(product.used), product.unit, product.service_ratio, unitsShort)
        : `${roundUp(Number(product.used), 2)} ${unitsShort}`

    const formattedMaxValue = product.threshold === ThresholdValue.NOT_APPLICABLE
        ? t('screens:dashboard.unlimited')
        : isTimeUnit
            ? convertToMinutesAndSeconds(Number(product.threshold), product.unit, product.service_ratio, unitsShort)
            : roundUp(Number(product.threshold), 2)

    return (
        <div className={classes.resourceMeterContainer }>
            <div
                className={useStyling ? classes.usedQuantity : undefined}
                data-testid={usedQuantityElementId}
                data-qa={usedQuantityElementId}
            >{formattedCurrentValue}
            </div>
            <div className={classes.maxQuantity}>/</div>
            <div
                className={useStyling ? classes.maxQuantity : undefined}
                data-testid={maxQuantityElementId}
                data-qa={maxQuantityElementId}
            >{formattedMaxValue}</div>
        </div>
    )
}

export default ResourceMeter